import { useBoringVaultV1 } from 'boring-vault-ui';
import { useQuery } from '@tanstack/react-query';
import { useConnection } from 'modules/auth';

export const useUserUnlockTime = () => {
  const { isConnected, address } = useConnection();
  const { fetchUserUnlockTime, isBoringV1ContextReady } = useBoringVaultV1();

  return useQuery({
    queryKey: ['userUnlockTime', address],
    queryFn: async () => {
      if (!address) throw new Error('User address is required');
      return fetchUserUnlockTime(address);
    },
    enabled: isConnected && !!address && isBoringV1ContextReady,
    staleTime: 60 * 1000,
  });
};
